<ng-container [ngSwitch]="chartType">
    <div class="chart">
        <bi-bar-chart *ngSwitchCase="'bar'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel"
                      [chartType]="chartType" [selectedRefLine]="selectedRefLine"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-bar-chart>

        <bi-bar-chart *ngSwitchCase="'column'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                      [selectedRefLine]="selectedRefLine"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-bar-chart>

        <bi-pie-chart *ngSwitchCase="'pie'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-pie-chart>

        <bi-donut-chart *ngSwitchCase="'donut'" (memberSelection)="memberSelected($event)"
                        (onDropSuccess)="itemDropped($event.dragData)"
                        [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                        [childHierarchies]="childHierarchies"
                        [dropZones]="['dimension', 'measure']" [height]="height"
                        [seriesData]="seriesData" dnd-droppable></bi-donut-chart>

        <bi-bar-chart *ngSwitchCase="'area'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                      [selectedRefLine]="selectedRefLine"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-bar-chart>

        <bi-bar-chart *ngSwitchCase="'line'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                      [selectedRefLine]="selectedRefLine"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-bar-chart>

        <bi-bar-chart *ngSwitchCase="'spline'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                      [selectedRefLine]="selectedRefLine"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-bar-chart>

        <bi-bar-chart *ngSwitchCase="'areaspline'" (memberSelection)="memberSelected($event)"
                      (onDropSuccess)="itemDropped($event.dragData)"
                      [title]="title" [xAxisLabel]="xAxisLabel" [chartType]="chartType"
                      [selectedRefLine]="selectedRefLine"
                      [childHierarchies]="childHierarchies"
                      [dropZones]="['dimension', 'measure']" [height]="height"
                      [seriesData]="seriesData" dnd-droppable></bi-bar-chart>

        <bi-grid-chart *ngSwitchCase="'grid'" (onDropSuccess)="itemDropped($event.dragData)"
                       [title]="title" [height]="height" [dropZones]="['dimension', 'measure']"
                       [seriesData]="seriesData"
                       [childHierarchies]="childHierarchies"
                       (memberSelection)="memberSelected($event)" dnd-droppable></bi-grid-chart>

        <bi-summary-card *ngSwitchCase="'summary'" (onDropSuccess)="itemDropped($event.dragData)"
                         [title]="title" [dropZones]="['dimension', 'measure']"
                         [seriesData]="seriesData" dnd-droppable></bi-summary-card>

        <bi-blank-chart *ngSwitchDefault (added)="add()"
                        (onDropSuccess)="itemDropped($event.dragData)" (removed)="remove()"
                        [dropZones]="['dimension', 'measure']" [height]="height" dnd-droppable></bi-blank-chart>

        <div *ngIf="showActions" class="chart-tool-panel">
            <div class="chart-tool-panel-buttons">
                <fui-context-button (click)="remove()" [title]="'wbo.bi.button.removeChart'"
                                    class="chart-tool-panel-buttons-remove"></fui-context-button>
                <fui-context-button (click)="add()" [title]="'wbo.bi.button.addChart'"
                                    class="chart-tool-panel-buttons-add"></fui-context-button>
            </div>
        </div>

        <div *ngIf="!showActions && chartType !== 'summary'" class="chart-drill-panel">
            <div class="chart-drill-panel-buttons">
                <fui-action (click)="drillUp.emit()" [attr.title]="'wbo.bi.button.drillUp' | translate"
                            [disabled]="!enableDrillUp">
                    <fui-icon [height]="22" [icon]="'circle-arrow-up'" [width]="22"
                              class="chart-drill-panel-buttons-up"></fui-icon>
                </fui-action>

                <fui-action (click)="drillDown.emit()" [attr.title]="'wbo.bi.button.drillDown' | translate"
                            [disabled]="!enableDrillDown">
                    <fui-icon [height]="22" [icon]="'circle-arrow-down'" [width]="22"
                              class="chart-drill-panel-buttons-down"></fui-icon>
                </fui-action>
            </div>
        </div>
    </div>
</ng-container>
